import api from './authService';

const handleError = (error) => {
  if (error.response) {
    const { data } = error.response;
    return {
      message: data.message || 'An error occurred',
      errors: data.errors || {},
      status: error.response.status,
    };
  }
  if (error.request) {
    return { message: 'Network error. Please check your connection.', status: 0 };
  }
  return { message: error.message || 'An error occurred', status: 0 };
};

export const getAdminVendorPayoutVendors = async (params = {}) => {
  try {
    const response = await api.get('/admin/vendor-payouts/vendors', { params });
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
};

export const getAdminAccountingOverview = async () => {
  try {
    const response = await api.get('/admin/accounting/overview');
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
};

export const getAdminVendorAccountingStatement = async (vendorProfileId, params = {}) => {
  try {
    const response = await api.get(`/admin/accounting/vendors/${vendorProfileId}/statement`, { params });
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
};

export const getAdminVendorDisbursements = async (vendorProfileId, params = {}) => {
  try {
    const response = await api.get(`/admin/vendor-payouts/vendors/${vendorProfileId}/disbursements`, { params });
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
};

export const postAdminVendorDisbursement = async (vendorProfileId, payload) => {
  try {
    const response = await api.post(`/admin/vendor-payouts/vendors/${vendorProfileId}/disbursements`, payload);
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
};

export const postAdminVendorConnectTransfer = async (vendorProfileId, payload = {}) => {
  try {
    const response = await api.post(
      `/admin/vendor-payouts/vendors/${vendorProfileId}/connect-transfer`,
      payload
    );
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
};

export const postAdminVendorPayoutFreeze = async (vendorProfileId, payload) => {
  try {
    const response = await api.post(
      `/admin/vendor-payouts/vendors/${vendorProfileId}/payout-freeze`,
      payload
    );
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
};

export const postAdminVendorConnectDisconnect = async (
  vendorProfileId,
  payload = { delete_remote: true }
) => {
  try {
    const response = await api.post(
      `/admin/vendor-payouts/vendors/${vendorProfileId}/connect-disconnect`,
      payload
    );
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
};

export const postAdminVendorConnectReverse = async (vendorProfileId, disbursementId, payload = {}) => {
  try {
    const response = await api.post(
      `/admin/vendor-payouts/vendors/${vendorProfileId}/disbursements/${disbursementId}/reverse`,
      payload
    );
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
};

export const deleteAdminVendorDisbursement = async (vendorProfileId, disbursementId) => {
  try {
    const response = await api.delete(`/admin/vendor-payouts/vendors/${vendorProfileId}/disbursements/${disbursementId}`);
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
};

export const getVendorPayoutSummary = async () => {
  try {
    const response = await api.get('/vendor/payout-disbursements/summary');
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
};

export const getVendorAccountingStatement = async (params = {}) => {
  try {
    const response = await api.get('/vendor/accounting/statement', { params });
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
};

export const getVendorPayoutDisbursements = async (params = {}) => {
  try {
    const response = await api.get('/vendor/payout-disbursements', { params });
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
};
